import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import CampaignProgress from './CampaignProgress';
import GoalDetails from '../Food/GoalDetails.jsx';
import MediumMedia from './MediumMedia';
import TargetingConfig from './TargetingConfig';
import BudgetReview from './BudgetReview';
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import StarOutlineIcon from "@mui/icons-material/StarOutline";
import CampaignOutlinedIcon from "@mui/icons-material/CampaignOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import WorkspacePremiumOutlinedIcon from "@mui/icons-material/WorkspacePremiumOutlined";
import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import ThumbUpAltOutlinedIcon from "@mui/icons-material/ThumbUpAltOutlined";
import MouseOutlinedIcon from "@mui/icons-material/MouseOutlined";
import PhoneInTalkOutlinedIcon from "@mui/icons-material/PhoneInTalkOutlined";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import AutoFixHighOutlinedIcon from "@mui/icons-material/AutoFixHighOutlined";
import ChatBubbleOutlineOutlinedIcon from "@mui/icons-material/ChatBubbleOutlineOutlined";
import ScienceOutlinedIcon from "@mui/icons-material/ScienceOutlined";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import FlagOutlinedIcon from "@mui/icons-material/FlagOutlined";
import WebOutlinedIcon from "@mui/icons-material/WebOutlined";
import ContactPageOutlinedIcon from "@mui/icons-material/ContactPageOutlined";
import AdPreview from './AdPreview';
import { FOOD_API } from '../../../../config/api';
import { getVendors } from "../../../../Component/Servicefile/campaignService";
const Createcampaignfirst = ({ scrollToTop, selectedPlan, selectedFeature, onBack, }) => {
    const navigate = useNavigate();
    const [showPayment, setShowPayment] = useState(false);


    const [currentStep, setCurrentStep] = useState(() => {
        // Start from Step 1 for Menu Discount, BOGO Menu and Combo Offers
        if (
            (selectedFeature?.goal === "discount" &&
                selectedFeature?.subGoal?.toLowerCase() === "menu") ||

            (selectedFeature?.goal === "BOGO_DISCOUNT" &&
                selectedFeature?.subGoal?.toLowerCase() === "menu") ||

            (selectedFeature?.goal === "Combos" &&
                selectedFeature?.subGoal?.toLowerCase() === "offers")
        ) {
            return 1;
        }

        // Everything else starts from Step 2
        return 2;
    });

    const [showItemSelector, setShowItemSelector] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState('all');
    const [searchTerm, setSearchTerm] = useState('');
    const [isGenerating, setIsGenerating] = useState(false);
    const [showAIPrompt, setShowAIPrompt] = useState(false);
    const [aiPromptText, setAiPromptText] = useState('');
    const [screensData, setScreensData] = useState([]);
    const [groupedItems, setGroupedItems] = useState({});
    const [vendorsData, setVendorsData] = useState([]);
    const [itemDiscounts, setItemDiscounts] = useState({});
    const [formData, setFormData] = useState({
        campaignId: `CMP-${String(Date.now()).slice(-6)}`,
        name: '',
 vendorId: '',
        goal: '',
        subGoal: '',
        mediums: [],
        audience: [],
        appScreens: [],
        callToAction: '',
        placements: [],
        appTypes: [],
        mediaTypes: [],
        mediaDurations: {
            text: '',
            image: '',
            video: ''
        },
        imagePrompts: [],
        aiGeneratedImages: [],
        videoFile: null,
        images: [],
        interests: [],
        areaType: 'country',
        areaValue: '',
        days: '',
        reach: '',
        investment: '',
        startDate: '',
        endDate: '',
        durationCount: '',
        goalConfig: {
            leads: {
                leadSource: '',
                ctaType: '',
                contactName: '',
                contactMobile: '',
                serviceInterest: '',
                gender: '',
                ageRange: [18, 60],
                locations: [],
                interests: [],
                followUpDate: '',
                mediumMapping: {
                    app: { clickToCall: false, whatsapp: false }
                }
            },
            branding: {
                brandName: '',
                subGoal: '',
                contentType: '',
                callToAction: '',
                areaRadius: '',
                mediumMapping: {
                    app: { banner: false, feedAd: false }
                }
            },
            discount: {
                applicableOn: '',
                selectedItems: [],
                discountType: 'percentage',
                discountValue: '',
                validDays: '',
                timeSlot: '',
                mediumMapping: {
                    app: { offerCard: false, pushNotification: false },
                    digital: { social: false, whatsapp: false },
                    physical: { tableTent: false, poster: false }
                }
            }

        }
    });
    // ✅ In CreateCampaign.jsx — move these here from Goal component 
    const selectedDiscountItems =
        formData?.goalConfig?.discount?.selectedItems || [];

    const selectedBogoItems =
        formData?.goalConfig?.bogo?.selectedItems || [];
    // Various data combined information
    const [menuItems, setMenuItems] = useState([]);
    const containerRef = useRef(null);
    // const selectedBogoItems =
    //     formData?.goalConfig?.discount?.selectedItems || [];
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);


    // 👇 Maps a pricing-card title to its matching app placement value.
    // .trim().toLowerCase() handles the leading-space title in the Combos plans (" In-App Popup").
    const PLAN_TITLE_TO_PLACEMENT = {
        "in-app popup": "in_app_popup",
        "banner": "place_banner",
        "deals": "adds",
        "checkout": "cart",
    };

    const restrictPlacement = selectedPlan?.title
        ? PLAN_TITLE_TO_PLACEMENT[selectedPlan.title.trim().toLowerCase()] || null
        : null;

    // ✅ ADD THIS — single source of truth, reused by both mediumMediaProps and budgetReviewProps
    const durationUnit =
        selectedPlan?.durationUnit ||
        selectedPlan?.plan?.durationUnit ||
        null;

    // 👇 NEW — single source of truth, same pattern as restrictPlacement/durationUnit
    const restrictMediaType =
        selectedPlan?.mediaType ||
        selectedPlan?.plan?.mediaType ||
        null;
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        if (!selectedFeature) return;

        setFormData((prev) => ({
            ...prev,
            goal: selectedFeature.goal,
            subGoal: selectedFeature.subGoal,
            mediums: restrictPlacement
                ? Array.from(new Set([...(prev.mediums || []), "app"]))
                : prev.mediums,
            placements: restrictPlacement ? [restrictPlacement] : prev.placements,
            planPrice: selectedPlan?.price ?? selectedPlan?.plan?.price ?? prev.planPrice, // ✅ ADD THIS LINE
            durationUnit: durationUnit ?? prev.durationUnit,
        }));
    }, [selectedFeature, restrictPlacement, selectedPlan, durationUnit]); // ✅ add selectedPlan as a dependency


    useEffect(() => {
        const fetchVendors = async () => {
            try {
                const data = await getVendors();
                const validVendors = (data || []).filter(
                    v => v.registeredName && v.registeredName.trim() !== ""
                );
                setVendorsData(validVendors);
            } catch (err) {
                console.error("❌ Error fetching vendors:", err);
            }
        };
        fetchVendors();
    }, []);


    useEffect(() => {
        const fetchMenuItems = async () => {
            const vendorId = localStorage.getItem("vendorId");
            const token = localStorage.getItem("authToken");

            if (!vendorId || !token) return;

            try {
                const response = await fetch(
                    `${FOOD_API}/dish/getbyvendor/${vendorId}`,
                    {
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );

                if (!response.ok) {
                    throw new Error("Failed to fetch menu");
                }

                const dishData = await response.json();

                const formatted = [];

                // Level 1 -> Categories
                const categories = dishData.filter(item => item.parentId === 0);

                categories.forEach(category => {

                    // Level 2 -> Sub Categories
                    const subCategories = dishData.filter(
                        item => item.parentId === category.dishId
                    );

                    subCategories.forEach(subCategory => {

                        // Level 3 -> Menu Items
                        const menuItems = dishData.filter(
                            item => item.parentId === subCategory.dishId
                        );

                        menuItems.forEach(menu => {
                            formatted.push({
                                id: menu.dishId,
                                name: menu.dishName,

                                // Main Category
                                category: category.dishName,

                                // Sub Category
                                subCategory: subCategory.dishName,

                                price: Number(menu.price || 0),
                                image: menu.dishImage || "",
                                tag: menu.tag || "Veg",
                                menuStatus: menu.menuStatus || "Enable",

                                selected: false,
                                discountType: "percentage",
                                discountValue: "",
                                buyQty: "",
                                getQty: ""
                            });
                        });

                    });

                });



                setMenuItems(formatted);

            } catch (error) {
                console.error(error);
            }
        };

        fetchMenuItems();
    }, []);




    useEffect(() => {
        const grouped = {};

        menuItems.forEach(item => {
            if (!grouped[item.category]) {
                grouped[item.category] = {};
            }

            if (!grouped[item.category][item.subCategory]) {
                grouped[item.category][item.subCategory] = [];
            }

            grouped[item.category][item.subCategory].push(item);
        });

        setGroupedItems(grouped);
    }, [menuItems]);
    const steps = [
        { number: 1, label: 'Goal Details' },
        { number: 2, label: 'Medium & Media' },
        { number: 3, label: 'Targeting' },
        { number: 4, label: 'Budget' },
        // { number: 5, label: 'Review' }
    ];

    const goals = [
        { value: 'leads', label: 'Leads' },
        { value: 'branding', label: 'Branding' },
        { value: 'discount', label: 'Discount' },
        {
            value: "BOGO_DISCOUNT",
            label: "Buy One Get One"
        },
        {
            value: "Combos",
            label: "Combo Offers"
        }
    ];
    const safeMediums = formData?.mediums || [];
    const safePlacements = formData?.placements || [];
    const adPreviewRef = useRef(null);
    const subGoals = {
        leads: [

            {
                value: "whatsapp_messages",
                label: "Get more WhatsApp messages",
                description: "Create an ad that includes the call-to-action button from your Page.",
                icon: <WhatsAppIcon sx={{ fontSize: 22, color: "#3d4451" }} />,
                iconBg: "#f0f2f5",
            },


            {
                value: "more_calls",
                label: "Get more calls",
                description: "",
                icon: <PhoneInTalkOutlinedIcon sx={{ fontSize: 22, color: "#3d4451" }} />,
                iconBg: "#f0f2f5",
            },
            {
                value: "website_visitors",
                label: "Get more website visitors",
                description: "Create an ad to send people to your website.",
                icon: <MouseOutlinedIcon sx={{ fontSize: 22, color: "#3d4451" }} />,
                iconBg: "#f0f2f5",
            },
            {
                value: "more_leads",
                label: "Get more leads",
                description: "Create an ad to request contact details from potential customers.",
                icon: <ContactPageOutlinedIcon sx={{ fontSize: 22, color: "#3d4451" }} />,
                iconBg: "#f0f2f5",
            },
        ],
        branding: [
            {
                value: "awareness",
                label: "Brand Awareness",
                description: "Introduce your brand to new audiences",
                icon: <VisibilityOutlinedIcon sx={{ fontSize: 20, color: "#185FA5" }} />,
            },
            {
                value: "recall",
                label: "Brand Recall",
                description: "Stay top of mind with your audience",
                icon: <CampaignOutlinedIcon sx={{ fontSize: 20, color: "#3B6D11" }} />,
            },
            {
                value: "premium",
                label: "Premium Positioning",
                description: "Build a high-value brand perception",
                icon: <WorkspacePremiumOutlinedIcon sx={{ fontSize: 20, color: "#854F0B" }} />,
            },
        ],
        discount: [
            {
                value: "new_customers",
                label: "New Customers",
                description: "Attract first-time buyers with deals",
                icon: <PeopleAltOutlinedIcon sx={{ fontSize: 20, color: "#185FA5" }} />,
            },
            {
                value: "existing_customers",
                label: "Existing Customers",
                description: "Reward loyalty with exclusive offers",
                icon: <CheckCircleOutlineIcon sx={{ fontSize: 20, color: "#3B6D11" }} />,
            },
            {
                value: "all_customers",
                label: "All Customers",
                description: "Run a wide discount for everyone",
                icon: <GroupsOutlinedIcon sx={{ fontSize: 20, color: "#533AB7" }} />,
            },
            {
                value: "specific_items",
                label: "Specific Items",
                description: "Discount selected products only",
                icon: <ShoppingCartOutlinedIcon sx={{ fontSize: 20, color: "#854F0B" }} />,
            },
        ],
        Combos: [
            {
                value: "offers",
                label: "Combo Offers",
                description: "Create meal combinations",
                icon: <ShoppingCartOutlinedIcon />
            }
        ]
    };
    const subGoalLabels = {
        leads: [
            // { value: "new_customers", label: "New Customers" },
            // { value: "existing_customers", label: "Existing Customers" },
            // { value: "high_value", label: "High Value Customers" },
            // { value: "more_messages", label: "Get More Messages" },
            { value: "whatsapp_messages", label: "Get more WhatsApp messages" },
            // { value: "more_page_likes", label: "Get more Page likes" },
            { value: "more_calls", label: "Get more calls" },
            { value: "website_visitors", label: "Get more website visitors" },
            { value: "more_leads", label: "Get more leads" },
        ],

        branding: [
            { value: "awareness", label: "Brand Awareness" },
            { value: "recall", label: "Brand Recall" },
            { value: "premium", label: "Premium Positioning" },
        ],

        discount: [
            // ⚠️ REMOVE if backend does not support
            // { value: "advertisement", label: "Advertisement" },
            // { value: "menu", label: "Menu" },
        ],
    };


    const handleInputChange = (field, value) => {
        setFormData(prev => {
            // ✅ If value is an object (like mediaDescriptions)
            if (typeof value === "object" && !Array.isArray(value)) {
                return {
                    ...prev,
                    [field]: {
                        ...prev[field],
                        ...value
                    }
                };
            }

            // ✅ Normal fields (like websiteUrl, name, callToAction)
            return {
                ...prev,
                [field]: value
            };
        });
    };
    // 1. Add this at the top of CreateCampaignPremium component (with other useState/useRef)
    const stepRef = useRef(null);
    useEffect(() => {
        if (stepRef.current && containerRef.current) {
            const container = containerRef.current;
            const element = stepRef.current;

            const offset = 520; // adjust this

            const elementTop = element.offsetTop;

            container.scrollTo({
                top: elementTop - offset,
                behavior: "smooth"
            });
        }
    }, [currentStep]);
    // 2. Replace your scrollToTop function with this
    useEffect(() => {

    }, [formData]);



    const handleGoalConfigChange = (goalType, field, value) => {
        setFormData(prev => ({
            ...prev,
            goalConfig: {
                ...prev.goalConfig,
                [goalType]: {
                    ...prev.goalConfig[goalType],
                    [field]: value
                }
            }
        }));
    };

    const handleMultiSelect = (field, value) => {
        // ✅ SPECIAL CASE (single select)
        if (field === "durationSeconds") {
            setFormData(prev => ({
                ...prev,
                [field]: value
            }));
            return;
        }

        // ✅ existing logic for arrays
        setFormData(prev => {
            const current = Array.isArray(prev[field]) ? prev[field] : [];

            const updated = current.includes(value)
                ? current.filter(v => v !== value)
                : [...current, value];

            return {
                ...prev,
                [field]: updated
            };
        });
    };


    const handleMediaDurationChange = (mediaType, value) => {
        setFormData(prev => ({
            ...prev,
            mediaDurations: {
                ...prev.mediaDurations,
                [mediaType]: value
            }
        }));
    };




    const handleImageUpload = (e) => {
        const file = e.target.files[0]; // ✅ take only one file

        if (!file) return;

        const reader = new FileReader();

        reader.onloadend = () => {
            setFormData(prev => ({
                ...prev,
                images: [reader.result],          // ✅ replace old image
                imagePrompts: ['']                // ✅ reset prompt
            }));
        };

        reader.readAsDataURL(file);

        // optional: allow same file re-upload
        e.target.value = null;
    };

    const handleVideoUpload = (e) => {
        const file = e.target.files[0]; // ✅ only one video

        if (!file) return;

        const videoUrl = URL.createObjectURL(file);

        setFormData(prev => ({
            ...prev,
            videoFile: videoUrl   // ✅ replaces old video automatically
        }));

        // ✅ allow re-upload of same file
        e.target.value = null;
    };

    const removeImage = (index) => {
        setFormData(prev => ({
            ...prev,
            images: prev.images.filter((_, i) => i !== index),
            imagePrompts: prev.imagePrompts.filter((_, i) => i !== index)
        }));
    };

    const removeVideo = () => {
        setFormData(prev => ({
            ...prev,
            videoFile: null
        }));
    };

    const onInputChange = (key, value) => {
        setFormData(prev => ({
            ...prev,
            [key]: value
        }));
    };

    const handleAIGenerate = () => {
        if (!aiPromptText.trim()) {
            alert('Please enter a prompt');
            return;
        }

        setIsGenerating(true);

        setTimeout(() => {
            const seed = Math.floor(Math.random() * 1000);
            const aiImageUrl = `https://picsum.photos/seed/${seed}/400/400`;

            setFormData(prev => ({
                ...prev,
                images: [...prev.images, aiImageUrl],
                imagePrompts: [...prev.imagePrompts, aiPromptText],
                aiGeneratedImages: [...(prev.aiGeneratedImages || []), aiImageUrl]
            }));

            setIsGenerating(false);
            setShowAIPrompt(false);
            setAiPromptText('');
        }, 2000);
    };
    // document.addEventListener('scroll', e => console.log('scrolling element:', e.target.className || e.target.tagName), true);
    const getStepFlow = () => {
        const { goal, subGoal } = formData;

        // Buy One Get One
        if (goal === "BOGO_DISCOUNT") {
            return [1, 2, 3, 4];
        }
        if (goal === "Combos") {
            return [1, 2, 3, 4];
        }
        // Discount Campaign
        if (goal === "discount") {

            if (subGoal === "menu") {
                return [1, 2, 3, 4];
            }

            if (subGoal === "coupons") {
                return [1, 2, 3, 4];
            }

            if (subGoal === "advertisement") {
                return [1, 2, 3, 4];
            }


            return [1, 3, 4];
        }

        // Branding / Leads
        return [1, 2, 3, 4];
    };



    // const handleNext = () => {

    //     // ✅ BOGO Flow
    //     if (
    //         currentStep === 1 &&
    //         formData.goal === "BOGO_DISCOUNT"
    //     ) {
    //         setCurrentStep(3);
    //         scrollToTop?.();
    //         return;
    //     }

    //     const flow = getStepFlow();
    //     const currentIndex = flow.indexOf(currentStep);

    //     // ✅ Custom navigation from Step 2 based on medium
    //     if (currentStep === 2) {

    //         if (formData.mediums.includes("digital")) {

    //             setCurrentStep(4);
    //             scrollToTop?.();
    //             return;

    //         }

    //         if (formData.mediums.includes("app")) {

    //             setCurrentStep(3);
    //             scrollToTop?.();
    //             return;

    //         }
    //     }

    //     // ✅ Default Flow
    //     if (currentIndex < flow.length - 1) {

    //         setCurrentStep(
    //             flow[currentIndex + 1]
    //         );

    //     }

    //     scrollToTop?.();
    // };



    const handleNext = () => {
        const { goal, subGoal } = formData;



        // Percentage Discount
        if (currentStep === 1 && goal === "discount" && subGoal === "menu") {
            setCurrentStep(2);
            return;
        }

        // Flat Discount Coupons
        if (goal === "discount" && subGoal === "COUPONS") {
            setCurrentStep(2);
            return;
        }

        // Buy 1 Get 1
        if (currentStep === 1 && goal === "BOGO_DISCOUNT" && subGoal === "menu") {
            setCurrentStep(2);
            return;
        }

        // Existing logic
        const flow = getStepFlow();
        const currentIndex = flow.indexOf(currentStep);

        if (currentStep === 2) {
            if (formData.mediums.includes("digital")) {
                setCurrentStep(4);
                return;
            }

            if (formData.mediums.includes("app")) {
                setCurrentStep(3);
                return;
            }
        }

        if (currentIndex < flow.length - 1) {
            setCurrentStep(flow[currentIndex + 1]);
        }
    };


    const handleBack = () => {
        const flow = getStepFlow();
        const currentIndex = flow.indexOf(currentStep);

        // ✅ If coming back from Step 4 and digital was selected → go to 2
        if (currentStep === 4 && formData.mediums.includes('digital')) {
            setCurrentStep(2);
            return;
        }

        if (currentIndex > 0) {
            setCurrentStep(flow[currentIndex - 1]);
        }

    };
    // ✅ Step 1 valid without subGoal for discount 
    const isStepValid = () => {

        switch (currentStep) {

            case 1:

                if (
                    formData.goal === "discount" ||
                    formData.goal === "BOGO_DISCOUNT" ||
                    formData.goal === "Combos"
                ) {
                    return !!formData.goal;
                }

                return (
                    formData.goal &&
                    formData.subGoal
                );

            case 2:
                const mediaValid =
                    formData.mediaTypes.length > 0;

                const mediumValid =
                    formData.mediums.length > 0;

                const appAudienceValid =
                    formData.mediums.includes("app")
                        ? formData.audience.length > 0
                        : true;

                const appScreensValid =
                    formData.mediums.includes("app")
                        ? formData.appScreens.length > 0
                        : true;

                return (
                    mediaValid &&
                    mediumValid &&
                    appAudienceValid &&
                    appScreensValid
                );

            case 3:
                return true;

            case 4:
                return (
                    formData.days ||
                    formData.reach ||
                    formData.investment
                );

            default:
                return true;
        }

    };



    const loadRazorpayScript = () => {
        return new Promise((resolve) => {
            const script = document.createElement('script');
            script.src = 'https://checkout.razorpay.com/v1/checkout.js';
            script.onload = () => resolve(true);
            script.onerror = () => resolve(false);
            document.body.appendChild(script);
        });
    };

    const handlePayment = async () => {
        const res = await loadRazorpayScript();

        if (!res) {
            alert('Razorpay SDK failed to load. Please check your internet connection.');
            return;
        }

        const options = {
            key: 'YOUR_RAZORPAY_KEY_ID',
            amount: parseInt(formData.investment) * 100,
            currency: 'INR',
            name: 'Campaign Payment',
            description: `Payment for campaign ${formData.campaignId}`,
            handler: function (response) {
                handleSubmit();
            },
            prefill: {
                name: 'Customer Name',
                email: 'customer@example.com',
                contact: '9999999999'
            },
            notes: {
                campaignId: formData.campaignId,
                campaignName: formData.name
            },
            theme: {
                color: '#667eea'
            }
        };

        const paymentObject = new window.Razorpay(options);
        paymentObject.open();
    };

    const handleSubmit = () => {
        alert('Campaign created successfully!');
        navigate('/campaigns');
    };



    const isPaymentValid = () => {
        return formData.investment && parseInt(formData.investment) > 0;
    };

    // Props for child components
    const goalDetailsProps = {
        formData,
        campaignName: formData.campaignName,
        goals,
        subGoals,
        onInputChange: handleInputChange
    };

    const mediumMediaProps = {
        // ── spread individual formData fields ──
        campaignName: formData.campaignName,
        websiteUrl: formData.websiteUrl,
        goal: formData.goal,
        name: formData.name,
        subGoal: formData.subGoal,
        mediums: formData.mediums,
        audience: formData.audience,
        mediaTypes: formData.mediaTypes,
        mediaDurations: formData.mediaDurations,
        mediaDescriptions: formData.mediaDescriptions,
        callToAction: formData.callToAction,
        images: formData.images,
        aiGeneratedImages: formData.aiGeneratedImages,
        videoFile: formData.videoFile,
        appTypes: formData.appTypes,
        restrictPlacement,
        vendorId: formData.vendorId,     // 👈 ADD THIS
        vendorsData,
        // durationUnit: selectedPlan?.durationUnit || selectedPlan?.plan?.durationUnit || null,
        durationUnit,               // ✅ was: selectedPlan?.durationUnit || selectedPlan?.plan?.durationUnit || null
        durationCount: formData.durationCount,
        restrictMediaType,
        selectedPlan,
        // ── handlers ──
        onInputChange: handleInputChange,
        onMultiSelect: handleMultiSelect,
        onMediaDurationChange: handleMediaDurationChange,
        onImageUpload: handleImageUpload,
        onVideoUpload: handleVideoUpload,
        onRemoveImage: removeImage,
        onRemoveVideo: removeVideo,
        showAIPrompt,
        setShowAIPrompt,
        aiPromptText,
        setAiPromptText,
        isGenerating,
        onAIGenerate: handleAIGenerate,
        goals,
        screensData: screensData,
        setScreensData: setScreensData,
        subGoals: subGoalLabels,
        onNext: handleNext,
        onBack: handleBack,
        placements: formData.placements,
        durationSeconds: formData.durationSeconds,
        handleGoalConfigChange,
        goalConfig: formData.goalConfig,
    };
    const targetingConfigProps = {
        formData,
        goal: formData.goal,
        goalConfig: formData.goalConfig,
        onGoalConfigChange: handleGoalConfigChange,
        showItemSelector,
        setShowItemSelector,
        selectedCategory,
        setSelectedCategory,
        searchTerm,
        setSearchTerm,

        // ✅ NEW ADDITIONS (IMPORTANT)
        restrictMediaType, // 👈 NEW — "image" | "video" chosen on the pricing card
        discountType: formData.goalConfig?.discount?.discountType,
        selectedItems: formData.goalConfig?.discount?.selectedItems || [],
        startTime: formData.goalConfig?.discount?.startTime,
        endTime: formData.goalConfig?.discount?.endTime,
        timeCategory: formData.goalConfig?.discount?.timeCategory,
        // ⭐⭐⭐ ADD THIS
        onNext: handleNext,
        onBack: handleBack,

        images: formData.images,
        onImageUpload: handleImageUpload,
        onRemoveImage: removeImage,
    };

    const budgetReviewProps = {
        currentStep,
        formData,
        steps,
        goals,        // ← is this here?
        subGoals,     // ← is this here?
        onInputChange: handleInputChange,
        onMultiSelect: handleMultiSelect,
        onNext: handleNext,
        onBack: handleBack,
        onPayment: handlePayment,
        isStepValid,
        isPaymentValid,
        durationUnit,                     // ✅ now defined at top level — no more no-undef
        goalConfig: formData.goalConfig,
    };

    const mediumOptions = [
        { value: 'app', label: 'App' },
        { value: 'digital', label: 'Digital' },
        { value: 'physical', label: 'Physical' }
    ];
    const audienceOptions = [
        { value: 'users', label: 'Users' },
        { value: 'vendors', label: 'Vendors' },
        { value: 'companies', label: 'Companies' },
        { value: 'movers', label: 'Movers' }
    ];
    const mediaTypeOptions = [
        { value: 'image', label: 'Image' },
        { value: 'video', label: 'Video' }
    ];
    const callToActionOptions = [
        { value: 'apply_now', label: 'Apply now' },
        { value: 'book_now', label: 'Book now' },
        { value: 'contact_us', label: 'Contact us' },
        { value: 'download', label: 'Download' },
        { value: 'learn_more', label: 'Learn more' },
        { value: 'request_time', label: 'Request time' },
        { value: 'see_menu', label: 'See menu' },
        { value: 'shop_now', label: 'Shop now' },
        { value: 'sign_up', label: 'Sign up' },
        { value: 'watch_more', label: 'Watch more' },
        { value: 'send_message', label: 'Send message' },
        { value: 'get_quote', label: 'Get quote' },
        { value: 'get_directions', label: 'Get directions' },
        { value: 'call_now', label: 'Call now' },
        { value: 'enquire_now', label: 'Enquire now' },
        { value: 'order_now', label: 'Order now' },
        { value: 'refer_and_earn', label: 'refer now' },

    ];
    const interestOptions = [
        { value: "food", label: "🍔 Food Lovers" },
        { value: "veg", label: "🥗 Veg Lovers" },
        { value: "students", label: "🎓 Students" },
        { value: "families", label: "👨‍👩‍👧 Families" },
        { value: "office", label: "💼 Office Crowd" }
    ];
    return (
        <div className="campaign-creator" ref={containerRef}>
            <CampaignProgress
                currentStep={currentStep}
                steps={steps}
                onBack={onBack}
                goal={formData.goal}
                onStepClick={(step) => {
                    if (
                        (formData.goal === "discount" &&
                            formData.subGoal === "menu") ||
                        formData.goal === "BOGO_DISCOUNT"
                    ) {
                        if (step === 2) return;
                    }

                    setCurrentStep(step);
                }}
                isDiscount={
                    (formData.goal === "discount" &&
                        formData.subGoal === "menu") ||
                    formData.goal === "BOGO_DISCOUNT"
                }
            />

            <div className="campaign-content" >
                <div
                    style={{
                        display: "grid",
                        gridTemplateColumns: isMobile ? "1fr" : "1fr 380px",
                        // gap: "24px",
                        alignItems: "start",
                        width: "100%",
                        padding: "0px",
                        boxSizing: "border-box",
                    }}
                >
                    {/* ── Left Column — fixed fluid width ── */}
                    <div
                        style={{
                            minWidth: 0,
                            width: "100%",
                            height: window.innerWidth >= 1200 && window.innerWidth <= 1400 ? "290px" : "420px",
                            overflow: "auto",
                            scrollbarWidth: "none",
                        }}
                        className="create-campaign-data"
                    >
                        {currentStep === 1 && (
                            <GoalDetails
                                formData={formData}
                                goals={goals}
                                subGoals={subGoals}
                                onInputChange={handleInputChange}
                                handleGoalConfigChange={handleGoalConfigChange}
                                onNext={handleNext}
                                menuItems={menuItems}
                                setMenuItems={setMenuItems}
                                groupedItems={groupedItems}
                                setGroupedItems={setGroupedItems}
                                selectedFeature={selectedFeature}

                            />
                        )}
                        <div className='medium-media-data-code'>
                            {currentStep === 2 && <MediumMedia {...mediumMediaProps} />}
                        </div>
                        <div ref={stepRef} style={{ marginTop: "-15px" }}>
                            {currentStep === 3 && <TargetingConfig {...targetingConfigProps}
                                setShowPayment={setShowPayment}
                                adPreviewRef={adPreviewRef}

                            />}
                        </div>
                        <div style={{ marginTop: "-21px" }}>
                            {currentStep === 4 &&
                                <BudgetReview {...budgetReviewProps}
                                    isBudgetStep={true}
                                    showPayment={showPayment}
                                    setShowPayment={setShowPayment}
                                    adPreviewRef={adPreviewRef}
                                />}
                        </div>
                        <div style={{ marginTop: "-15px", }}>
                            {currentStep === 5 && <BudgetReview {...budgetReviewProps} isBudgetStep={false} />}
                        </div>
                    </div>

                    {/* ── Right Column — fixed 380px Ad Preview ── */}
                    <div
                        ref={adPreviewRef}
                        className="ad-preview-section"
                        style={{
                            // width: "25vw",
                            flexShrink: 0,
                            position: "sticky",
                            top: "24px",
                            height: "55vh",          // 👈 FIXED HEIGHT
                            overflowY: "auto",        // 👈 ENABLE SCROLL
                            border: "1px solid #eee", // optional
                            borderRadius: "10px",
                            scrollbarWidth: "none",
                            // 👇 media condition
                            ...(window.innerWidth >= 1200 && window.innerWidth <= 1500 && {
                                height: "45vh",
                            }),
                        }}
                    >
                        <AdPreview
                            formData={formData}
                            screensData={screensData}
                            menuItems={menuItems}
                            groupedItems={groupedItems}
                            goals={goals}
                            subGoals={subGoals}
                            callToActionOptions={callToActionOptions}
                            mediumOptions={mediumOptions}
                            audienceOptions={audienceOptions}
                            mediaTypeOptions={mediaTypeOptions}
                            interestOptions={interestOptions}
                            safeMediums={safeMediums}
                            safePlacements={safePlacements}
                            showPayment={showPayment}
                            setShowPayment={setShowPayment}
                            discountValue={formData?.goalConfig?.discount?.discountValue || ""}
                            discountMode={formData?.goalConfig?.discount?.discountType || "percentage"}
                            onInputChange={onInputChange}
                            bogoItems={formData?.goalConfig?.discount?.selectedItems || []}
                            itemDiscounts={itemDiscounts}
                            selectedDiscountItems={selectedDiscountItems}
                            selectedBogoItems={selectedBogoItems}
                            bogoItems={selectedBogoItems}
                            vendorsData={vendorsData}
                        />
                    </div>

                </div>
            </div>
        </div>
    );
};

export default Createcampaignfirst;





